export default __webpack_public_path__ + "static/media/avatar_7_2.b5452d59.png";